'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _b_ = require('b_');

var _b_2 = _interopRequireDefault(_b_);

var _index = require('../y-base/index.js');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../y-pointerfocus/index.js');

var _index4 = _interopRequireDefault(_index3);

require('./index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YRadio = function (_YBase) {
	_inherits(YRadio, _YBase);

	function YRadio(props) {
		_classCallCheck(this, YRadio);

		var _this = _possibleConstructorReturn(this, (YRadio.__proto__ || Object.getPrototypeOf(YRadio)).call(this, props));

		_this._refRootCb = _this._refCallback.bind(_this, 'root');
		return _this;
	}

	_createClass(YRadio, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			(0, _index4.default)();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    mix = _props.mix,
			    theme = _props.theme,
			    size = _props.size,
			    children = _props.children,
			    disabled = _props.disabled,
			    checked = _props.checked,
			    rest = _objectWithoutProperties(_props, ['mix', 'theme', 'size', 'children', 'disabled', 'checked']);

			var classes = (0, _b_2.default)('y-radio', {
				checked: checked,
				theme: theme,
				size: size,
				disabled: disabled
			}) + ' ' + mix;

			var text = '';

			if (children) {
				this._tagName = 'label';
				text = _react2.default.createElement(
					'span',
					{ className: 'y-radio__text' },
					children
				);
			} else {
				this._tagName = 'span';
			}

			return _react2.default.createElement(
				this._tagName,
				{
					className: classes // eslint-disable-line react/forbid-component-props
					, ref: this._refRootCb
				},
				_react2.default.createElement(
					'span',
					{ className: 'y-radio__box' },
					_react2.default.createElement('input', _extends({}, rest, {
						className: 'y-radio__control',
						type: 'radio',
						checked: checked,
						disabled: disabled
					})),
					_react2.default.createElement('span', { className: 'y-radio__view' }),
					_react2.default.createElement('span', { className: 'y-radio__point' })
				),
				text
			);
		}
	}]);

	return YRadio;
}(_index2.default);

exports.default = YRadio;


YRadio.propTypes = {
	mix: _propTypes2.default.string,
	theme: _propTypes2.default.string,
	size: _propTypes2.default.string
};

YRadio.defaultProps = {
	mix: '',
	theme: 'normal',
	size: 'm',
	checked: false,
	disabled: false
};